export { default as Resume } from './resume';
